module.exports = __webpack_public_path__ + "media/images/common/ui/ico_select_arrow-103f638ff011cbd9a164da1b8c0a47b1.png";